import { render, staticRenderFns } from "./ModalTableMaterial.vue?vue&type=template&id=fb916e04&scoped=true"
import script from "./ModalTableMaterial.vue?vue&type=script&lang=js"
export * from "./ModalTableMaterial.vue?vue&type=script&lang=js"
import style0 from "./ModalTableMaterial.vue?vue&type=style&index=0&id=fb916e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb916e04",
  null
  
)

export default component.exports